import { render, staticRenderFns } from "./consignmenttracking_mr.vue?vue&type=template&id=58c7c3e0"
import script from "./consignmenttracking_mr.vue?vue&type=script&lang=js"
export * from "./consignmenttracking_mr.vue?vue&type=script&lang=js"
import style0 from "./consignmenttracking_mr.vue?vue&type=style&index=0&id=58c7c3e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports